import React, { useState } from 'react';
import JobDetail from '../expandedCard/jobDetail';
import { useDispatch } from 'react-redux'

const ExpandedCard = (props) => {

    const [currentNoteIndex, setCurrentNoteIndex] = useState(null);
    const [currentNote, setCurrentNote] = useState(null);
    const dispatch = useDispatch()

    const handleUpdate = (isOpen = false, noteIndex = null, note = null) => {

        if (isOpen) {
            dispatch({ type: 'REPLY_NOTE', payload: true })
            setCurrentNoteIndex(noteIndex);
            setCurrentNote(note);
        }
    };

    return (
        <div className="expandedcard_content">
            <JobDetail
                replyBack={handleUpdate}
                isCardChanged={props?.isCardChanged}
                item={props?.item}
                changeBackground={props?.changeBackground}
                currentUser={props?.currentUser}
                currentNoteIndex={currentNoteIndex}
                currentNote={currentNote}
                onArchiveJob={props?.onArchiveJob}
                isNewJob={props.isNewJob}
            />
        </div>
    )
};

export default React.memo(ExpandedCard);